<template>
  <div class="tad-field" :class="fieldClass">
    <label v-if="label" class="tad-field__label" :for="fieldId">
      {{ label }}<span v-if="required" class="tad-field__asterisk">*</span>
    </label>
    <div class="tad-field__control-wrap">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Label wrapper for ticket form controls.
 * Slot inputs should use bindings from @/constants/ticketActionFieldInput.js
 */
let fieldCounter = 0;

export default {
  name: "TicketActionField",
  props: {
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    fieldClass: { type: String, default: "" },
  },
  data() {
    fieldCounter += 1;
    return {
      fieldId: `tad-field-${fieldCounter}`,
    };
  },
};
</script>
